export default "__VITE_ASSET__d6dc2a7a__"